import {ILanguage} from '@app/shared/models/language.model';
import {createAction, props} from '@ngrx/store';

export enum LanguageActions {
  GetLanguages = '[LanguageSelector component] get available languages',
  GetLanguagesSuccess = '[Language Effects] get language success',
  GetLanguagesFailure = '[Language Effects] get language failure',
  SetPreferredLanguage = '[LanguageSelector component] set customer preferred language',
  SetPreferredLanguageSuccess = '[Language Effects] set customer preferred language success',
  SetPreferredLanguageFailure = '[Language Effects] set customer preferred language failure',
  SetLanguageFromHeaderEffect = '[Header Effect] Set customer preferred language from header effect',
  SetLanguageFromLanguageEffect = '[Language Effect] Set customer preferred language from language effect',
}

export const getLanguages = createAction(LanguageActions.GetLanguages);
export const getLanguagesSuccess = createAction(LanguageActions.GetLanguagesSuccess, props<{languages: ILanguage[]}>());
export const getLanguagesFailure = createAction(LanguageActions.GetLanguagesFailure);

export const setPreferredLanguage = createAction(LanguageActions.SetPreferredLanguage, props<{languageId: string}>());

export const setPreferredLanguageSuccess = createAction(LanguageActions.SetPreferredLanguageSuccess);
export const setPreferredLanguageFailure = createAction(LanguageActions.SetPreferredLanguageFailure);

export const setLanguageFromHeaderEffect = createAction(
  LanguageActions.SetLanguageFromHeaderEffect,
  props<{languageId: string}>()
);

export const setLanguageFromLanguageEffect = createAction(
  LanguageActions.SetLanguageFromLanguageEffect,
  props<{languageId: string}>()
);
